export default __webpack_public_path__ + "static/media/logo-lg (3).df3acd90.png";